import InputSearch from "../../../components/Basic/InputSearch";
import { useFilter } from "../../../contexts/FilterContext";

export default function TaskSearch() {
    const [search, set] = useFilter(state => state.search)

    return <div>
        <div className="text-[15px] mt-4 mb-3">Create and customize operation tasks to match your workflow.</div>
        <InputSearch
            className="max-w-[400px] w-full"
            placeHolder='Search combined treatment, service task by name'
            value={search}
            onChange={(v) => set({ search: v })}
        />
    </div>
}